import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import type { Booking } from '../types/booking';
import { advertiserBookingState, needsAdvertiser } from '../constants/advertiserBookingState';

/**
 * How many bookings wait on the advertiser right now (approved, unpaid).
 * Shown as the badge on Bookings in the sidebar. Shares the ['bookings']
 * query with the pages that list them, so paying updates it at once.
 */
export function useAdvertiserNeedsYou(enabled: boolean): number {
    const { data } = useQuery<Booking[]>({
        queryKey: ['bookings'],
        queryFn: async () => (await api.get('/bookings')).data.data ?? [],
        enabled,
        staleTime: 60_000,
    });
    if (!enabled || !data) return 0;
    return data.filter((b) => needsAdvertiser(advertiserBookingState(b))).length;
}
